// A wrapper around axios with TS and async/await
import axios from "axios"
axios.defaults.adapter = require("axios/lib/adapters/http")

// Note: we are setting API url as a data attribute on body - may pass
// this in more of global way in React via Context or similar in the future
const apiRoot =
  window.document.body.dataset.apiRoot || "http://monsters-local.kuali.d:3000/"

/**
 * Create an Axios Client with baseURL as default
 */
export const client = axios.create({
  baseURL: apiRoot
})

/**
 * A lightweight wrapper for axios - a Promise based HTTP client for the browser and node.js
 * see https://github.com/axios/axios#request-config for config options
 */
const request = async (options: {}) => {
  const onSuccess = (response) => {
    // console.debug("Request successfull:", response)
    return response
  }
  const onError = (error: {
    config: {}
    response: { status: string; data: {}; headers: {} }
    message: string
  }) => {
    console.error("Request failed:", error.config)
    if (error.response) {
      console.error("Status:", error.response.status)
      console.error("Data:", error.response.data)
      console.error("Headers:", error.response.headers)
    } else {
      // log message if it wasn't based on the response
      console.error("Error Message:", error.message)
    }

    return error.response || error.message
  }

  const response = await client(options)
    .then(onSuccess)
    .catch(onError)

  return response
}

export default request
